import React from 'react';
import SearchControlText from './SearchControlText';
import SearchControlAlphabetical from './SearchControlAlphabetical';
import SearchControlOHT from './SearchControlOHT';
import { useReactiveVar } from '@apollo/client';
import { userPrivileges } from '../../../apollo/cache';
import PrivilegeNames from '../../../constants/privilegeNames';

/**
 * @typedef {object} SearchControlsProps
 * @property {(searchState: { searchText?: string, searchChar?: string, searchOHT?: Array<number>, currentPage?: number }) => void} setSearchState
 * @property {string} [selectedSearchText]
 * @property {string} [selectedSearchChar]
 * @property {Array<number>} [selectedSearchOHTs]
 * @property {string} searchTextPlaceholder
 */

/**
 * @param {SearchControlsProps} props
 */
const SearchControls = props => {
  const {
    setSearchState,
    selectedSearchText,
    selectedSearchOHTs,
    selectedSearchChar,
    searchTextPlaceholder
  } = props;
  const privileges = useReactiveVar(userPrivileges);

  const hasSearchControlsPrivilege =
    privileges.includes(PrivilegeNames.UnitSearch) ||
    privileges.includes(PrivilegeNames.OrganizationSearch_Advanced) ||
    privileges.includes(PrivilegeNames.OrganizationSearch_Standard);

  return (
    <div className='search-units__controls'>
      {hasSearchControlsPrivilege && (
        <div>
          <SearchControlText
            placeholder={searchTextPlaceholder}
            selectedSearchText={selectedSearchText}
            setSearchText={val => setSearchState({ searchText: val, currentPage: 1 })}
          />
          <SearchControlOHT
            selectedSearchOHTs={selectedSearchOHTs}
            setSearchOHT={val => setSearchState({ searchOHT: val, currentPage: 1 })}
          />
          <SearchControlAlphabetical
            setSearchChar={val => setSearchState({ searchChar: val, currentPage: 1 })}
            selectedSearchChar={selectedSearchChar}
          />
        </div>
      )}
      {privileges.includes(PrivilegeNames.UnitSelection) && (
        <SearchControlText
          placeholder={searchTextPlaceholder}
          setSearchText={val => setSearchState({ searchText: val, currentPage: 1 })}
        />
      )}
    </div>
  );
};

export default SearchControls;
